
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { IAppCoreState } from 'src/app/core/state';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash-es';
import { selectAppNotification } from 'src/app/core/state/selectors';
import { IAppNotificationState } from 'src/app/core/state/reducers/app-notification.reducer';
import { DealRoute } from 'src/app/shared/model/api';
import { NavigationExtras, Router } from '@angular/router';
import { AppNotification } from 'src/app/shared/model/api/AppNotification';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import * as appNotificationsActions from '../../../state/actions/app-notification.action';
import * as appCustomerInfoActions from 'src/app/shared/state/actions/customer-info.action';
import { ViewConstants } from 'src/app/constants';
import { getDetailsForInitiatedWriteup } from 'src/app/shared/state/selectors';
import { FeatureFlagService } from 'src/app/environment/services/feature-flag.service';

@Component({
    selector: 'con-app-notification-panel',
    templateUrl: './con-app-notification-panel.html',
    styleUrls: ['con-app-notification-panel.scss'],
    standalone: false
})
export class ConAppNotificationPanel implements OnInit, OnDestroy {
  private readonly _subs = new SubSink();
  public notifications: IAppNotificationState;
  public isToggle = true;
  darkTheme = false;
    private readonly _sub = new SubSink();

  constructor(private readonly _store: Store<IAppCoreState>, private readonly router: Router,
    private readonly featureFlagService: FeatureFlagService,
    public readonly sharedDataService: SharedDataService) {
  }

  public ngOnInit() {
    this.darkTheme = this.sharedDataService.getDarkThemeValue();
    this._subs.sink = this._store.select(selectAppNotification).subscribe(o => {
      setTimeout(() => {
        if(this.notifications.notificationsList.length==0 && document.getElementById("crossIcon")){
          document.getElementById("crossIcon").focus();
        }else{
          document.getElementById("NotificationCard0")?.focus();
        }
     }, 500);
      this.notifications = { ...o };

      this.isToggle=o.isToggle;
      if(!this.isToggle)
      {
        this.notifications.notificationsList=this.notifications.notificationsList
        .filter(element=>(element.deal.reviewManager!=null && element.deal.reviewManager.length>0 && element.deal.reviewManager
        .filter(e => e.id.toString().toLowerCase() === this.sharedDataService.loggedInUserId.toString().toLowerCase()).length > 0))
        .filter(e => e.deal.onlineStatus.toLowerCase() != ViewConstants.ONLINE_STATUS_READY_FOR_DEALER.toLowerCase())
      }
    });
   
  }

  public ngOnDestroy() {
    this._subs.unsubscribe();
  }

  public close() {
    this._store.dispatch(appNotificationsActions.AppNotificationHidePanel());
  }

  public clearAll() {

    if (this.notifications?.notificationsList?.length > 0) {
      this._store.dispatch(appNotificationsActions.AppNotificationClearAll());
    }
  }
  //
  // navigate to writeup-details
  //
  public navigateToWriteup(item: AppNotification) {
    const navExtra = this.getNavigationExtras(item);
    this.router.onSameUrlNavigation = "reload";

    if(item?.deal?.status?.toLowerCase() === ViewConstants.INITIATED.toLowerCase() && item?.deal?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase() && this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED'))
       {
        let data ={};
        data['deal'] = {};
        data['deal']['dealTransactionId'] = item?.deal?.dealTransactionId;

        this._store.dispatch(appCustomerInfoActions.GetDealDetailsForInitiatedModalAction({ payload: data }));
          this._subs.sink = this._store.select(getDetailsForInitiatedWriteup)
        .subscribe((res: any) => {
          if(!isNil(res) && res.dealCallStatus) {
            this.sharedDataService.initiatedWriteupRowData = res.custWriteups;
            this.sharedDataService.initiatedWriteupRowData['deal'] ={}
            this.sharedDataService.initiatedWriteupRowData['deal']['status'] = item?.deal?.status;
            setTimeout(() => {
            this.sharedDataService.resFromNotificationCenter  =  true;
              this.sharedDataService.openInitiateModal = true;
              if (this.router.url?.includes('cs/customer-summary/')) {
                this.router.navigate(['/wl/summary']);
              }
            }, 800);
          }
          });
       }
       else if((item?.deal?.dealType === "TRADEIN" && item?.deal?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase() && this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED')) ||
        (this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED') && item?.deal?.status?.toLowerCase() !== ViewConstants.INITIATED.toLowerCase() && item?.deal?.onlineStatus?.toLowerCase() === ViewConstants.INITIATED.toLowerCase() && item?.deal?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase())){
          if(isNil(navExtra?.state?.dealType) || navExtra?.state?.dealType === ''|| navExtra?.state?.dealType.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase()){
            navExtra.state.dealType = "Trade";
          }
          this.router.navigate(['wd/writeup-detail'], navExtra);
        }
      else{
          this.router.navigate(['wd/writeup-detail'], navExtra);
      }
    this.close();
  }
  //
  // return data required for navigating to writeup-details module
  //
  private getNavigationExtras(data: AppNotification) {

    const dealRoute: DealRoute = {};
    if(data.customer){
      dealRoute.customer = data.customer.firstName + data.customer.lastName;
    }
    dealRoute.dealType = data.deal.writeupType;
    dealRoute.dealStatus = data.deal.status;
    dealRoute.dealTransactionId = data.deal.dealTransactionId;
    dealRoute.salesConsultant = data.deal.salesPerson;
    dealRoute.isNotification = true;
    dealRoute.timestamp = Date.now();
    const navigationExtras: NavigationExtras = {
      // queryParams: {
      //   "dealRoute": JSON.stringify(dealRoute)
      // },
      skipLocationChange: false,
      state: dealRoute
    };

    return navigationExtras;
  }

  onChangeToggleEvent(event) {
    if(event){
      this._store.dispatch(appNotificationsActions.AppNotificationToggleOn());
    }
    else{
      this._store.dispatch(appNotificationsActions.AppNotificationToggleOff());
    }
  }
}

